import { AppKitNetwork, flare, songbird } from '@reown/appkit/networks'
import { defineChain } from '@reown/appkit/networks';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'

// Set up the WalletConnect and Wagmi configurations
export const coston = defineChain({
  id: 16,
  caipNetworkId: "eip155:16",
  chainNamespace: 'eip155',
  name: "Coston",
  nativeCurrency: {
    decimals: 18,
    name: "Coston",
    symbol: "CFLR",
  },
  rpcUrls: {
    public: { http: ["https://coston-api.flare.network/ext/C/rpc"] },
    default: { http: ["https://coston-api.flare.network/ext/C/rpc"] },
  },
  blockExplorers: {
    default: { name: "Coston explorer", url: "https://coston-explorer.flare.network" },
  },
})

export const coston2 = defineChain({
  id: 114,
  name: "Coston2",
  caipNetworkId: "eip155:114",
  chainNamespace: 'eip155',
  nativeCurrency: {
    decimals: 18,
    name: "Coston2",
    symbol: "C2FLR",
  },
  rpcUrls: {
    public: { http: ["https://coston2-api.flare.network/ext/C/rpc"] },
    default: { http: ["https://coston2-api.flare.network/ext/C/rpc"] },
  },
  blockExplorers: {
    default: { name: "Coston2 explorer", url: "https://coston2-explorer.flare.network" },
  },
});

// Set up the WalletConnect and Wagmi configurations
let projId: string;
if (import.meta.env.VITE_WALLET_CONNECT_PROJECT_ID) {
  projId = import.meta.env.VITE_WALLET_CONNECT_PROJECT_ID;
} else {
  throw Error(
    "WalletConnect project id not set! Should be set in .env file, look in documentation for instructions how to set up.",
  );
}
export const projectId = projId;

export const metadata = { //optional
    name: 'flare.space',
    description: 'flare.space',
    url: 'https://flare.space',
    icons: ['https://flare.space/images/flare-space-logo.svg']
}

// 3. Set the networks
export const networks = [flare, songbird, coston, coston2] as [AppKitNetwork, ...AppKitNetwork[]];

// 4. Create Wagmi Adapter
export const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
})

// 5. Create modal

export const excludeWalletIds = [
  "c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96",
  "3ff00412740baeb0ae71df4a1d2cc81e644cbaf66913094ee2e8465e8d04ed0c",
];

export const explorerRecommendedWalletIds = [
  "37a686ab6223cd42e2886ed6e5477fce100a4fb565dcd57ed4f81f7c12e93053", // Bifrost
  "19177a98252e07ddfc9af2083ba8e07ef627cb6103467ffebb3f8f4205fd7927", // Ledger
  "a1f506a38f39b672b369bd13b68abbbd81f83a0489e6625f2bf12aa0389c22ae", // D'Cent
  "e9ff15be73584489ca4a66f64d32c4537711797e30b6660dbcb71ea72a42b1f4", // Exodus
];

export const themeVariables = {
  "--w3m-font-family": '"IBM Plex Sans", "Helvetica Neue", sans-serif',
  "--w3m-accent-fill-color": "#f5f5f5",
  "--w3m-accent-color": "#d93f0b",
  "--w3m-background-color": "none",
  "--w3m-color-overlay": "none",
  "--w3m-color-fg-1": "#d93f0b",
  "--w3m-overlay-background-color": "",
  "--w3m-overlay-backdrop-filter": "",
  "--w3m-z-index": 5000,
};
